import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { MapPin, Star } from "lucide-react";

const ShabbatSection = () => {
  const { t } = useTranslation();

  const fadeIn = {
    hidden: { opacity: 0, y: 24 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } }
  };

  return (
    <section data-testid="shabbat-section" className="bg-charcoal py-24 md:py-32 px-6 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMDAiIGhlaWdodD0iMzAwIj48ZmlsdGVyIGlkPSJhIiB4PSIwIiB5PSIwIj48ZmVUdXJidWxlbmNlIGJhc2VGcmVxdWVuY3k9Ii43NSIgc3RpdGNoVGlsZXM9InN0aXRjaCIgdHlwZT0iZnJhY3RhbE5vaXNlIi8+PGZlQ29sb3JNYXRyaXggdHlwZT0ic2F0dXJhdGUiIHZhbHVlcz0iMCIvPjwvZmlsdGVyPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbHRlcj0idXJsKCNhKSIvPjwvc3ZnPg==')]" />
      <motion.div
        className="max-w-2xl mx-auto text-center relative z-10"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
      >
        {/* Icon */}
        <motion.div variants={fadeIn} className="mb-6">
          <Star className="w-6 h-6 text-gold mx-auto" strokeWidth={1} />
        </motion.div>

        {/* Title */}
        <motion.h2
          variants={fadeIn}
          className="font-serif text-white text-3xl md:text-5xl tracking-tight mb-3"
        >
          {t("shabbat_title")}
        </motion.h2>

        <motion.div variants={fadeIn}>
          <div className="w-16 h-px bg-gold mx-auto mt-6 mb-10" />
        </motion.div>

        {/* Dates */}
        <motion.div variants={fadeIn} className="space-y-4 mb-10">
          <div>
            <p className="font-sans text-white/80 text-base md:text-lg tracking-wide">
              {t("shabbat_friday")}
            </p>
            <p className="font-serif text-gold text-xs md:text-sm mt-1" dir="rtl">
              {t("shabbat_friday_hebrew")}
            </p>
          </div>
          <div className="w-8 h-px bg-gold/40 mx-auto" />
          <div>
            <p className="font-sans text-white/80 text-base md:text-lg tracking-wide">
              {t("shabbat_saturday")}
            </p>
            <p className="font-serif text-gold text-xs md:text-sm mt-1" dir="rtl">
              {t("shabbat_saturday_hebrew")}
            </p>
          </div>
        </motion.div>

        {/* Location */}
        <motion.div variants={fadeIn} className="flex items-center justify-center gap-2 text-white/50">
          <MapPin className="w-4 h-4 text-gold" strokeWidth={1.5} />
          <p className="font-sans text-sm md:text-base tracking-wide">
            {t("shabbat_address")}
          </p>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default ShabbatSection;
